import { Component, EventEmitter, Input, OnInit, Output, ViewChild, SimpleChanges, OnDestroy } from '@angular/core';
import { NgScrollbar } from 'ngx-scrollbar';
import { Subscription } from 'rxjs';
import { DataTableService } from 'src/app/service/data-table.service';
import { ActionMenuEvent } from '../actionmenu/action-menu.component';
import { DataTableColumn, DataTableFilter } from '../datatable/datatable.component';
import { PageEvent } from '../pagination/pagination.component';
import { TreeEvent } from '../tree/tree.component';

@Component({
    selector: 'app-dataview',
    templateUrl: './dataview.component.html',
    styleUrls: ['./dataview.component.css'],
    standalone: false
})
export class DataviewComponent implements OnInit, OnDestroy {

  @ViewChild(NgScrollbar) sidePanelScrollRef: NgScrollbar;

  @Input() showfiltericon: boolean = false;
  @Input() showtreeicon: boolean = false;
  @Input() showfilter: boolean = false;
  @Input() showtree: boolean = false;
  @Input() showaddicon: boolean = false;
  @Input() showcommenticon: boolean = false;
  @Input() showfavoriteicon: boolean = false;
  @Input() showsettingsicon: boolean = false;
  @Input() showshareicon: boolean = false;
  @Input() shareicontitle: string = $localize`Share`;
  @Input() showdragdrop: boolean = false;
  @Input() pagination: boolean = false;
  @Input() title: string;
  @Input() cols: DataTableColumn[];
  @Input() data: any[];
  @Input() filters: DataTableFilter[];
  @Input() treedata: any[];
  @Input() treesidenav: boolean = false;
  @Input() sidepaneltitle: string = "";
  @Input() url: string;
  @Input() showtablefilter: boolean = false;
  @Input() usetreescroll: boolean = false;
  @Input() identifier: string;
  @Input() isLoading: boolean = false;
  @Input() isResizable: boolean = false;
  @Input() showSwitchEnv: boolean = false;


  @Output() expandtreeevent: EventEmitter<TreeEvent> = new EventEmitter();
  @Output() changetreeevent: EventEmitter<SimpleChanges> = new EventEmitter();

  @Output() pageevent: EventEmitter<PageEvent> = new EventEmitter();
  @Output() numperpageevent: EventEmitter<any> = new EventEmitter();

  @Output() onclickheadertree: EventEmitter<any> = new EventEmitter();
  @Output() onclickheaderfilter: EventEmitter<any> = new EventEmitter();
  @Output() onclickheaderadd: EventEmitter<any> = new EventEmitter();
  @Output() onclickheadercomment: EventEmitter<any> = new EventEmitter();
  @Output() onclickheaderfavorite: EventEmitter<any> = new EventEmitter();
  @Output() onclickheadersettings: EventEmitter<any> = new EventEmitter();
  @Output() onclickheaderdragdrop: EventEmitter<any> = new EventEmitter();
  @Output() onclickswitchenv: EventEmitter<any> = new EventEmitter();
  @Output() onclickheaderdownload: EventEmitter<any> = new EventEmitter();

  @Output() actionmenuevent: EventEmitter<ActionMenuEvent> = new EventEmitter();


  total: number = 0;
  scrollRef: NgScrollbar;

  filterSubscription: Subscription;
  filterLoadedSubscription: Subscription;

  constructor(public dataTableSrv: DataTableService) { }

  ngOnInit(): void {
    this.filterSubscription = this.dataTableSrv.filterClicked$.subscribe((isDisplayed) => {
      setTimeout(() => this.showtablefilter = isDisplayed);
    });

    this.filterLoadedSubscription = this.dataTableSrv.filterLoaded$.subscribe(filterData => {
      this.filters = filterData;
    });
  }

  ngOnDestroy(): void {
    this.filterLoadedSubscription?.unsubscribe();
    this.filterLoadedSubscription?.unsubscribe();
  }

  //header actions

  onClickHeaderTree(): void {
    this.showtree = !this.showtree;
    this.onclickheadertree.emit();
  }

  onClickHeaderFilter(): void {
    this.showfilter = !this.showfilter;
    this.onclickheaderfilter.emit();
  }

  onClickHeaderAdd(): void {
    this.onclickheaderadd.emit();
  }

  onClickHeaderComment(): void {
    this.onclickheadercomment.emit();
  }

  onClickHeaderFavorite(): void {
    this.onclickheaderfavorite.emit();
  }

  onClickHeaderSettings(): void {
    this.onclickheadersettings.emit();
  }

  onClickHeaderDragDrop(): void{
    this.onclickheaderdragdrop.emit();
  }

  onClickSwitchEnv(): void {
    this.onclickswitchenv.emit()
  }

  onClickDownload(): void {
    this.onclickheaderdownload.emit();
  }
  
  //other actions

  actionMenuItemClicked(actionMenuItemEvent: ActionMenuEvent){
    this.actionmenuevent.emit(actionMenuItemEvent);
  }

  expandTree(treeEvent: TreeEvent) {
    this.expandtreeevent.emit(treeEvent);
  }

  changeTree(event: SimpleChanges) {
    this.showtablefilter = false;
    this.changetreeevent.emit(event);
  }

  onPageChange(pageEvent: PageEvent): void {
    this.pageevent.emit(pageEvent);
  }

}
